export default "__VITE_ASSET__Dl2y2Cjo__"